import React from 'react';
import { Box, Typography, TypographyVariant } from '@material-ui/core';

export const getTextComponent = (label: string, color: string, variant?: TypographyVariant): JSX.Element => (
  <Box color={color} width="100%" pb={0}>
    <Typography variant={variant || 'caption'}>{label}</Typography>
  </Box>
);
